import { forwardRef } from "react";
import { MenuItem as MuiMenuItem } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { mergeWith } from "lodash";

import { colors } from "theme";

enum MenuItemSizes {
  MD = "md",
  SM = "sm",
}

const useStyles = makeStyles(() => ({
  root: ({ size }: { size: MenuItemSizes }) => ({
    fontSize: size === MenuItemSizes.MD ? 18 : 12,
    lineHeight: size === MenuItemSizes.MD ? "26.24px" : "17.5px",
    letterSpacing: 0.5,
    fontWeight: 400,
    padding: size === MenuItemSizes.MD ? "15px 16px" : "7px 16px",
    color: colors.nero[300],
    borderBottom: `1px solid ${colors.grey[500]}`,
    "&:hover": {
      backgroundColor: colors.periwinkle[100],
    },
  }),
}));

const MenuItem = forwardRef(
  ({ classes = {}, size = MenuItemSizes.MD, ...otherProps }: any, ref: any) => {
    const baseClasses = useStyles({ size });
    const menuItemClasses = mergeWith(
      baseClasses,
      classes,
      (class1: string, class2: string) => `${class1} ${class2}`
    );

    return <MuiMenuItem ref={ref} {...otherProps} classes={menuItemClasses} />;
  }
);

export default MenuItem;
